var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBasketCart = function SvgBasketCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.833,
    clipPath: "url(#basket-cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.167a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834M18.334 20.167a.917.917 0 1 0 0-1.834.917.917 0 0 0 0 1.834M.917.917h3.667L7.04 13.19a1.83 1.83 0 0 0 1.834 1.476h8.91a1.83 1.83 0 0 0 1.833-1.476L21.084 5.5H5.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "basket-cart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgBasketCart;